import React, { useReducer, createContext } from 'react'

const SettingsContext = createContext({
    theme: 'dark',
    sideMenuCollapsed: 'false', // store as string
    updateTheme: () => {},
    toggleSideMenu: () => {},
})

function settingsReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_THEME':
            return { ...state, theme: action.payload }
        case 'TOGGLE_SIDE_MENU':
            return { ...state, sideMenuCollapsed: action.payload }
        default:
            return state
    }
}

function initSettings() {
    const storedTheme = localStorage.getItem('theme') || 'dark'
    const storedCollapsed = localStorage.getItem('sideMenuCollapsed') || 'false'
    return {
        theme: storedTheme,
        sideMenuCollapsed: storedCollapsed,
    }
}

const SettingsProvider = (props) => {
    const [state, dispatch] = useReducer(settingsReducer, undefined, initSettings)

    const updateTheme = (theme) => {
        localStorage.setItem('theme', theme)
        dispatch({ type: 'UPDATE_THEME', payload: theme })
    }

    const toggleSideMenu = (collapsed) => {
        const next =
            collapsed === 'true' || collapsed === 'false'
                ? collapsed
                : state.sideMenuCollapsed === 'true'
                  ? 'false'
                  : 'true'
        localStorage.setItem('sideMenuCollapsed', next)
        dispatch({ type: 'TOGGLE_SIDE_MENU', payload: next })
    }

    return (
        <SettingsContext.Provider
            value={{
                theme: state.theme,
                sideMenuCollapsed: state.sideMenuCollapsed,
                updateTheme,
                toggleSideMenu,
            }}
            {...props}
        />
    )
}

export { SettingsContext, SettingsProvider }
